/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBooleanLogicTreeContext } from "abreact/incubator/ui/abBooleanLogicTree/AbBooleanLogicTreeContext";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { NullUtils } from "abweb/utils/NullUtils";
import { Observer } from "mobx-react";
import * as React from "react";
export function LogicTreeDropAffordance(props) {
  const context = NullUtils.assertDefined(React.useContext(AbBooleanLogicTreeContext));
  /** See Initialization Explainer Below **/
  const [dropTargetId] = React.useState(context.dragDropMachine.generateDropTargetId.bind(context.dragDropMachine));
  return /*#__PURE__*/React.createElement(Observer, null, () => {
    const isCurrentDropTarget = context.dragDropMachine.currentDropTargetId === dropTargetId;
    const classNames = CssUtils.composeClassNames("ab-booltree-drop-affordance", props.className, isCurrentDropTarget && "ab-booltree-current-drop-target");
    return /*#__PURE__*/React.createElement("div", {
      className: classNames,
      key: "drop0",
      "data-test-id": "ab-booltree-drop-affordance",
      "data-drop-target-id": dropTargetId,
      "data-affordance-associated-key": props.associatedKey
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-booltree-drop-zone-indicator"
    }));
  });
}

/** Initialization Explainer:
 *  In this context we would like to generate a dropTargetId only once for the lifecycle of this component. To do so,
 *  we can populate the initialState value of the useState call to initialize our state. However, it is important to
 *  note that the useState call will be invoked on *every* render. As such, any function call used in the initialState
 *  will be called *every* render. The state will only be set on the initial call, but the function will be invoked
 *  and the produce values, which will be thrown away, on all subsequent renders. In some contexts this is okay, but in
 *  the case where the initialization function has side effects (like this one) or is computationally heavy, this behavior
 *  should be avoided.
 *  By passing in the function call, rather than the value produced by the function call, eg, (function1) vs (function1()),
 *  React will refrain from running the function on future renders, resulting in a side effect free state initialization.
 *  **/
//# sourceMappingURL=LogicTreeDropAffordance.js.map
